module.exports = __webpack_public_path__ + "img/United Arab Emirates (UAE).1563ae8b.svg";